// components/UI/KitcoWidget.jsx
import React from 'react';
import { Box, Paper, Typography, alpha, Button, Stack } from '@mui/material';
import { OpenInNew, Refresh } from '@mui/icons-material';

const KitcoWidget = ({ type = 'gold', height = 400, showTitle = true }) => {
  const [iframeKey, setIframeKey] = React.useState(Date.now());

  const getIframeUrl = () => {
    const baseUrl = 'https://www.kitco.com/charts';
    switch(type) {
      case 'gold':
        return `${baseUrl}/livegold.html`;
      case 'silver':
        return `${baseUrl}/livesilver.html`;
      case 'platinum':
        return `${baseUrl}/liveplatinum.html`;
      case 'palladium':
        return `${baseUrl}/livepalladium.html`;
      case 'copper':
        return `${baseUrl}/livecopper.html`;
      case 'all':
        return 'https://www.kitco.com/market/';
      default:
        return `${baseUrl}/livegold.html`;
    }
  };

  const getTitle = () => {
    switch(type) {
      case 'gold': return 'Live Gold Price Chart';
      case 'silver': return 'Live Silver Price Chart';
      case 'platinum': return 'Live Platinum Price Chart';
      case 'palladium': return 'Live Palladium Price Chart';
      case 'copper': return 'Live Copper Price Chart';
      case 'all': return 'Kitco Live Market Data';
      default: return 'Kitco Live Chart';
    }
  };

  const refreshIframe = () => {
    setIframeKey(Date.now());
  };

  const openInNewTab = () => {
    window.open(getIframeUrl(), '_blank');
  };

  return (
    <Paper
      sx={{
        p: 2,
        bgcolor: '#FFFFFF',
        borderRadius: 2,
        border: `1px solid ${alpha('#D4AF37', 0.2)}`,
        overflow: 'hidden',
        height: '100%',
      }}
    >
      {showTitle && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" sx={{ color: '#0a0a2a', fontWeight: 700 }}>
            {getTitle()}
          </Typography>
          <Stack direction="row" spacing={1}>
            <Button 
              size="small" 
              startIcon={<Refresh />} 
              onClick={refreshIframe}
              sx={{ fontSize: '0.7rem', color: '#D4AF37' }}
            >
              Refresh
            </Button>
            <Button 
              size="small" 
              startIcon={<OpenInNew />} 
              onClick={openInNewTab}
              sx={{ fontSize: '0.7rem', color: '#D4AF37' }}
            >
              Full Screen
            </Button>
          </Stack>
        </Box>
      )}
      
      <Box
        component="iframe"
        key={iframeKey}
        src={getIframeUrl()}
        sx={{
          width: '100%',
          height: height,
          border: 'none',
          borderRadius: 1,
          bgcolor: '#FFFFFF',
        }}
        title={getTitle()}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      />
    </Paper>
  );
};

export default KitcoWidget;